<template>
  <div class="app-container">
    <!--筛选组-->
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery">
        <el-form-item>
          <el-date-picker
            v-model="listQuery.betweenTime"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item>
          <el-input
            v-model="listQuery.search"
            placeholder="请输入相关内容"
            clearable
            style="width: 200px;"
            class="filter-item"
            @keyup.enter.native="SearchData"
          />
        </el-form-item> -->
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="SearchData"
          >搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <el-table-column type="index" align="center" width="100"></el-table-column>
      <!-- <el-table-column align="center" prop="create_date" label="日期"></el-table-column> -->
      <el-table-column align="center" prop="url" label="页面的URL"></el-table-column>
      <el-table-column align="center" prop="num" label="用户数"></el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />
  </div>
</template>

<script>
import api from '@/api/logs'
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
// import mixin from '@/mixins/mixin'
export default {
  name: 'UV',
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      api,
      listQuery: {
        limit: 15
      }
    }
  },
  created() {
    this.loadData() // 页面加载创建时加载数据
  },
  methods: {
    // 加载数据表
    loadData() {
      this.listLoading = true
      // 请求前处理
      this.loadListBefore(this.QueryParams)
      this.api.UvList(this.listQuery).then(response => {
        if (this.afterLoadData) {
          response.data.items = this.afterLoadData(response.data.items)
        }
        this.list = response.data.items
        this.total = response.data.total
        this.listLoading = false
        this.$previewRefresh() // 为图片预览组件重新刷新url
      }).catch((error) => {
        console.error('获取数据失败:', error)
      })
    }
  }
}
</script>
<style scoped>
.tableAuto.el-table .cell {
  white-space: nowrap;
}
</style>
